import { backendAxios } from "../Services/axios";

export interface impression {
  id: string;
  isFirst: boolean;
  sessionId: string;
}

export default class ImpressionsController {
  static async sendImpressions(payload: impression[]) {
    if (process.env.REACT_APP_IMPRESSIONS_ENABLED !== "true") {
      return;
    }
    try {
      const response = await backendAxios.post("impression", {
        collections: payload,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending impressions:", error);
      return null;
    }
  }
}
